window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Global ================*/
/**
 * Global Configurations
 * ------------------------------------------------------------------------------
 */
theme.config = {
  // Media queries & breakpoints based on src/styles/tools/variables.scss.liquid
  mediaQueries: {
    xs: 'screen and (max-width: 29.99em)',
    smallDown: 'screen and (max-width: 47.99em)',
    small: 'screen and (min-width: 30em) and (max-width: 47.99em)',
    smallUp: 'screen and (min-width: 30em)',
    mediumDown: 'screen and (max-width: 64em)',
    medium: 'screen and (min-width: 48em) and (max-width: 64em)',
    mediumUp: 'screen and (min-width: 48em)',
    largeDown: 'screen and (max-width: 79.99em)',
    large: 'screen and (min-width: 64.01em) and (max-width: 79.99em)',
    largeUp: 'screen and (min-width: 64em)',
    desktop: 'screen and (min-width: 64.01em)',
    desktopDown: 'screen and (max-width: 63.99em)',
    widescreen: 'screen and (min-width: 80em)'
  },
  breakpoints: {
    small: 480,
    medium: 768,
    large: 1024,
    widescreen: 1280
  }
};
if ((typeof ShopifyAPI) === 'undefined') {
  ShopifyAPI = {};
}

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery(form).serialize(),
      dataType: 'json',
      beforeSend: function(jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function(line_item) {
        if ((typeof callback) === 'function') {
          callback(line_item, form);
        } else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function(XMLHttpRequest, textStatus) {
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        } else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function(cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function() {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: function(cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        } else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function(XMLHttpRequest, textStatus) {
        $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function(jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

/*============================================================================
  Drawer modules
==============================================================================*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '[js-drawer-close]',
      open: '[js-drawer-open-' + position + ']',
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#page-container')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');
    
    if (this.$activeSource) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();

/**
 * Mobile Navigation Script
 * ------------------------------------------------------------------------------
 */

theme.MobileNav = (function() {
	var selectors = {
		mobileNavDrawer: '#mobile-nav-drawer'
	};
	var cache = {};

	function init() {
		cacheSelectors();
		initDrawer();
	}

	function cacheSelectors() {
		cache = {
			mobileNavDrawer: $(selectors.mobileNavDrawer)
		};
	}

	function initDrawer() {
		// Add required classes to HTML
		$('.js-drawer-open-left')
			.attr('aria-controls', 'mobile-nav-drawer')
			.attr('aria-expanded', 'false');

		theme.MobileNavDrawer = new theme.Drawers('mobile-nav-drawer', 'left');
	}

	return {
		init: init
	};
})();

/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {
  'use strict';
  /*global ShopifyAPI, slate, theme, Handlebars, Shopify */

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer;

  /*============================================================================
    PUBLIC METHODS - Initialise the plugin and define global options
  ==============================================================================*/
  function init(options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '#CartContainer',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      _qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      _formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    _adjustCart();
  }

  function loadCart() {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  /*============================================================================
    PRIVATE METHODS
  ==============================================================================*/
  function _updateCountPrice(cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(slate.Currency.formatMoney(cart.total_price, settings.moneyFormat));
    }
  }

  function _formOverride() {
    $('body').on('submit', settings.formSelector, function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, _itemAddedCallback, _itemErrorCallback);
    });
  }

  function _itemAddedCallback() {
    $addToCart.removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(_cartUpdateCallback);
  }

  function _itemErrorCallback(XMLHttpRequest, textStatus) {
    var data = JSON.parse(XMLHttpRequest.responseText);
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status === 422) {
        $formContainer.after('<div class="errors qty-error">' + data.description + '</div>');
        console.log(data, textStatus);
      }
    }
  }

  function _cartUpdateCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);
    _buildCart(cart);
  }

  function _buildCart(cart) {
    // Start with a fresh cart div
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer
        .append('<div class="ajaxcart__empty"><p>Your cart is currently empty.</p></div>');
      _cartCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
       */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: slate.Currency.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: slate.Currency.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: slate.Currency.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: slate.Currency.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings + ' ' + slate.Currency.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    };

    $cartContainer.append(template(data));

    _cartCallback(cart);
  }

  function _cartCallback(cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  }

  function _adjustCart() {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = $el.siblings('.ajaxcart__qty-num'),
        qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
        line = $el.data('line'),
        qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = _validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__product[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, _adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });
  }

  function _adjustCartCallback(cart) {
    // Update quantity and price
    _updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(_buildCart);
    }, 150);
  }

  function _createQtySelectors() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  }

  function _qtySelectors() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function() {
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var qty = _validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  }

  function _validateQty(qty) {
    if ((parseFloat(qty) === parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  }

  module = {
    init: init,
    load: loadCart
  };

  return module;

}(ajaxCart || {}, jQuery));

window.theme = window.theme || {};

theme.CartDrawer = new theme.Drawers('ajax-cart-drawer', 'right', {
  onDrawerOpen: ajaxCart.load
});

// Init ajax cart
ajaxCart.init({
  formSelector: '[data-product-form]',
  cartContainer: '#CartContainer',
  addToCartSelector: '[data-add-to-cart]',
  cartCountSelector: '[js-cart-count]',
  moneyFormat: theme.moneyFormat
});
// Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
jQuery(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
  theme.CartDrawer.open();
});

theme.Accordion = (function(){
  var selectors = {
    container: '[js-accordion-group]',
    header: '[js-accordion-header]',
    content: '[js-accordion-content]'
  }
  function init() {
    $('body').on('click', selectors.header, function(evt){
      var $el = $(this);
      var $accordionGroup = $(this).closest(selectors.container);
      if($el.attr('aria-expanded') == 'true'){
        //this stops the slide up triggering the parent;
        $el.siblings().slideUp(400, function() {
          $(this).attr('aria-hidden', true);
        })
        // This is closing the children accordions when the parent accordion is closed.
        $el.siblings(selectors.content).find(selectors.header).each(function(){
          $(this).attr('aria-expanded', false);
          $(this).siblings(selectors.content).slideUp(400, function() {
            $(this).attr('aria-hidden', true);
          });
          
          if ($accordionGroup.data('faq-accordion') == true) {
            $(this).parent().removeClass('page-faq__block--active');
          }
        })
        $el.attr('aria-expanded', false);

        if ($accordionGroup.data('faq-accordion') == true) {
          $el.parent().removeClass('page-faq__block--active');
        }
      } else {
        $el.parent().siblings().find(selectors.content, selectors.container).slideUp(400, function(){
          $(this).attr('aria-hidden', true);
          
          
          if ($accordionGroup.data('faq-accordion') == true) {
            $(this).parent().removeClass('page-faq__block--active');
          }
        });
        $el.parent().siblings().find(selectors.header, selectors.container).attr('aria-expanded', false);
        $el.siblings(selectors.content).slideDown().attr('aria-hidden', false);
        $el.attr('aria-expanded', true);
        
        if ($accordionGroup.data('faq-accordion') == true) {
          $el.parent().addClass('page-faq__block--active');
        }
      }
    })
  }
  return {
    init: init
  }
})();
theme.QuickAdd = (function() {
  var selectors = {
    quickAdd: '[js-quick-add]'
  }

  function init() {
    $('body').on('click', selectors.quickAdd, function() {
      var data = {
        id: $(this).data('id'),
        quantity: 1
      }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        async: false,
        dataType: 'json',
        data:  data,
        success: function(){
          ajaxCart.load();
        }
      })
    });
  }

  return {
    init: init
  };
})();

/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    carousel: '[js-product-carousel]',
    navItem: '[js-product-nav]',
    swatch: '[js-product-swatch]',
    swatchSubtext: '[js-swatch-subtext]',
    swatchFit: '[js-swatch-fit]',
    swatchLabel: '[js-swatch-label]',
    fitsLike: '[js-fits-like]',
    product: '[js-product]',
    availability: '[data-product-variant-inventory]',
    optionWidth: '[js-option-width]',
    accordions: '[js-product-accordions]',
    giftCardOption: '[js-gift-card-option]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    if ($(selectors.giftCardOption, this.$container).length > 1) {
      this.$container.find(selectors.giftCardOption, this.$container).on('click', function() {
        var price = $(this).text().trim();
  
        $(selectors.originalSelectorId, this.$container).children().each(function() {
          if (price === $(this).text().trim()) {
            var value = $(this).val();
  
            $(selectors.originalSelectorId, this.$container).val(value).trigger('change');
          }
        })
      })
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // Check if product has size option
    if (this.productSingleObject.options.some(opt => opt.toLowerCase() == 'size'))
      this.$container.on('variantChange' + this.namespace, this.fitsLike.bind(this));

    this.carousel(this.$container);
    this.productAccordions();

    this.$container.on('variantChange' + this.namespace, this.variantAvailability.bind(this));
    this.toggleSwatchesOnLoad(this.variants.product);
    this.toggleSwatchesOnVariantChange();
    this.productRecommendations();
    this.recentlyViewed();
    this.deleteRecentlyViewed();
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        var $width = $(selectors.optionWidth, this.$container);
        var valuesSize = $width.data('options-size');
        var optionsSelected = $(selectors.singleOptionSelector + ':checked', this.$container).length;

        if (valuesSize > 1 && optionsSelected < 2) {
          $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html('Select Width');
        } else {
          $(selectors.addToCart, this.$container).prop('disabled', false);
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        }
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    carousel: function($container) {
      var $carousel = $(selectors.carousel, $container);

      $carousel.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true
      });

      $carousel.on('change.flickity', function(event, index) {
        var $navHighlight = $(selectors.navItem + '[data-slide="' + index + '"]');

        $navHighlight.addClass('selected');
        $(selectors.navItem).not($navHighlight).removeClass('selected');
      });

      $(selectors.navItem).on('click', function() {
        var slide = $(this).data('slide');

        $carousel.flickity('select', slide, true, true);
        $(this).addClass('selected');
        $(selectors.navItem).not($(this)).removeClass('selected');
      });
    },

    productAccordions: function() {
      // close accordions on page load since the details element contains the attribute "open"
      // in the product description by default
      $(selectors.accordions, this.$container).find('details').each(function() {
        $(this).removeAttr('open');
      });
    },

    fitsLike: function(evt) {
      if (evt.variant) {
        var variantSize = '';

        if (evt.variant.options.length < 2) {
          variantSize = evt.variant.option1;
        } else {
          variantSize = evt.variant.option2;
        }
        var $newActiveFit = $('.product__size-' + variantSize + selectors.fitsLike, this.$container);

        $(selectors.swatchSubtext).addClass('hide');
        $(selectors.swatchFit).addClass('show');
        
        $newActiveFit.addClass('product__size-show');
        $(selectors.fitsLike, this.$container).not($newActiveFit).removeClass('product__size-show');
      }
    },

    toggleSwatchesOnLoad: function(product) {
      var variants = product.variants;

      for (var i = 0; i < variants.length; i++) {
        var variant = variants[i];

        if (variant.available) {
          for (var j = 0; j < variant.options.length; j++) {
            var option = variant.options[j];
            var potentialSwatch = $(selectors.swatch + '[data-value="' + option + '"]', this.$container);
            if (potentialSwatch.length) {
              potentialSwatch.removeClass('hide');
            }
          }
        }
      }
    },

    toggleSwatchesOnVariantChange: function() {
      $(selectors.swatchLabel + '.product-swatch__label-width', this.$container).on('click', function() {
        toggleSiblingSwatches($(this), 'width');
      });

      $(selectors.swatchLabel + '.product-swatch__label-size', this.$container).on('click', function() {
        toggleSiblingSwatches($(this), 'size');
      });

      function toggleSiblingSwatches(swatchLabel, type) {
        var allSiblingSwatches = [];
        var siblingSwatchesToShow = [];
        var value = swatchLabel.parent().data('value');

        $(selectors.originalSelectorId, this.$container).find('option').each(function() {
          var width = $(this).data('option-width');
          var size = $(this).data('option-size');
          var siblingSwatch;
          var thisSwatch;

          if (type == 'width') {
            siblingSwatch = size;
            thisSwatch = width;
          } else if (type == 'size') {
            siblingSwatch = width;
            thisSwatch = size;
          }

          if (!allSiblingSwatches.includes(siblingSwatch)) {
            allSiblingSwatches.push(siblingSwatch);
          }

          if ($(this).prop('disabled') || thisSwatch !== value) {
            return;
          }
          
          siblingSwatchesToShow.push(siblingSwatch);
        });

        for (var i = 0; i <allSiblingSwatches.length; i++) {
          if (siblingSwatchesToShow.includes(allSiblingSwatches[i])) {
            $(selectors.swatch + '[data-value="' + allSiblingSwatches[i] + '"]', this.$container).removeClass('hide');
          } else {
            $(selectors.swatch + '[data-value="' + allSiblingSwatches[i] + '"]', this.$container).addClass('hide');
          }
        }
      }
    },

    productRecommendations: function() {
      var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-recommendations");
        if (productRecommendationsSection === null) { return; }
        // Read product id from data attribute
        var productId = productRecommendationsSection.dataset.productId;
        // Read base URL from data attribute
        var baseUrl = productRecommendationsSection.dataset.baseUrl;
        // Read limit from data attribute
        var limit = productRecommendationsSection.dataset.limit;
        // Build request URL
        var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();
        request.open("GET", requestUrl);
        request.onload = function() {
          if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
          }
        };
        request.send();
      };

      // Listen for changes done in the Theme Editor
      document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
          loadProductRecommendationsIntoSection();
        }
      });
      // Fetching the recommendations on page load
      loadProductRecommendationsIntoSection();
    },

    variantAvailability: function(evt) {
      var variant = evt.variant;

      if (variant) {
        var id = variant.id;
        var $sizeElement = $(selectors.availability + '[data-id="' + id + '"]', this.$container);
        $sizeElement.removeClass('hide');
        $(selectors.availability).not($sizeElement).addClass('hide');
      }
    },

    recentlyViewed: function() {
      var recentlyViewed = [];
      var session = sessionStorage.getItem('recentlyViewed');
      var sessionParse = JSON.parse(session);
      var handle = $(selectors.product).data('handle');
      var timestamp = dayjs().$d.getTime();
      var product = {
        'handle' : handle,
        'time' : timestamp
      };

      if (sessionStorage.getItem('recentlyViewed') == null) {
        recentlyViewed.push(product);
        sessionStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
      } else if (sessionStorage.getItem('recentlyViewed').includes(handle) == false) {
        recentlyViewed.push(product);
        for (var i = 0; i < sessionParse.length; i++) {
          recentlyViewed.push(sessionParse[i]);
        }
        sessionStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
      }

      if (session !== null) {
        for (var i = 0; i < sessionParse.length; i++) {
          var difference = timestamp - sessionParse[i].time;
          var minutesSinceLastViewed = Math.floor(difference / 60000);

          $.ajax({
            type: 'GET',
            url: '/products/' + sessionParse[i].handle,
            dataType: 'json',
            async: false,
            success: function(data) {
              var title = data.product.title.split(' - ');
              var timeText = '';
              if (minutesSinceLastViewed >= 60) {
                var hours = Math.floor(minutesSinceLastViewed / 60);
                timeText = hours + ' hour' + (hours > 1 ? 's' : '') + ' ago';
              } else {
                timeText = minutesSinceLastViewed + ' minute' + (minutesSinceLastViewed > 1 ? 's' : '') + ' ago';
              }

              $('.product-recently-viewed').addClass('show');
              $('.product-recently-viewed').find('.product-recommendations__list').append(
                '<li class="product-recommendations__list-item' + (i > 5 ? ' hide' : '') + '">' +
                '<article class="product-card">' +
                '<div class="product-card__time">' +
                '<span class="product-card__time-text">' + timeText + '</span>' +
                '<button class="product-card__time-remove" data-handle="' + data.product.handle + '">X</button>' +
                '</div>' +
                '<a class="product-card__link" href="/products/' + data.product.handle + '">' +
                '<div class="product-card__image">' +
                '<img class="lazyloaded" src="' + data.product.image.src + '" />' +
                '</div>' +
                '<div class="product-card__image--hover">' +
                '<img class="lazyloaded" src="' + data.product.images[1]?.src + '" />' +
                '</div>' +
                '</a>' +
                '<h2 class="product-card__title">' + title[0] + '</h2>' +
                '<p class="product-card__color">' + title[1] + '</p>' +
                '<p class="product-card__price">' + slate.Currency.formatMoney(data.product.variants[0].price) + '</p>' +
                '</article>' +
                '</li>'
              );
            },
            error: function(err) {
              console.log(err);
            }
          });
        }
      }
    },

    deleteRecentlyViewed: function() {
      // clear all recently viewed products
      $('.product-recently-viewed__clear').on('click', function() {
        sessionStorage.removeItem('recentlyViewed');
        $('.product-recently-viewed').removeClass('show');
      });

      // remove single recently viewed product
      $('.product-card__time-remove').on('click', function() {
        var recentlyViewed = JSON.parse(sessionStorage.getItem('recentlyViewed'));
        var productHandle = $(this).data('handle');

        function findHandle(product) {
          return product.handle === productHandle;
        }

        var productIndex = recentlyViewed.findIndex(findHandle);
        recentlyViewed.splice(productIndex, 1);

        if (recentlyViewed.length >= 6) {
          $('.product-recently-viewed .product-recommendations__list-item').eq(6).removeClass('hide');
        }

        if (recentlyViewed.length) {
          sessionStorage.setItem('recentlyViewed', JSON.stringify(recentlyViewed));
        } else {
          sessionStorage.removeItem('recentlyViewed');
          $('.product-recently-viewed').removeClass('show');
        }

        $(this).closest('.product-recommendations__list-item').remove();
        if ($('.product-recently-viewed .product-recommendations__list-item').length == 0) {
          $('.product-recently-viewed').removeClass('show');
        }
      });
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();

theme.FeaturedCollection = (function() {

	function FeaturedCollection(container) {
		this.buildCarousel(container);
	}

	FeaturedCollection.prototype = $.extend({}, FeaturedCollection.prototype, {
		buildCarousel: function(container) {
			enquire.register(theme.config.mediaQueries.mediumUp,{
				match: function(){
					$(container).flickity({
						pageDots: false,
						cellAlign: 'left',
						wrapAround: true
					});
				}
			})
			.register(theme.config.mediaQueries.mediumDown,{
				match: function(){
					$(container).flickity({
						pageDots: false,
						cellAlign: 'left',
						wrapAround: true
					});
				}
			});
		}
	});

	return FeaturedCollection;
})();
theme.Testimonials = (function() {

	function Testimonials(container) {
		this.buildCarousel(container);
	}

	Testimonials.prototype = $.extend({}, Testimonials.prototype, {
		buildCarousel: function(container) {
		    enquire.register(theme.config.mediaQueries.smallDown,{
		      match: function(){
		      	$(container).flickity({
					pageDots: true,
					prevNextButtons: false,
					cellAlign: 'left',
					wrapAround: true,
					adaptiveHeight: true
				});
		      },
		      unmatch: function(){
		      	if ($(container).hasClass('flickity-enabled') ) {
					$(container).flickity('destroy');
				}
		      }
		    })
		}
	});

	return Testimonials;
})();
theme.SiteFooter = (function() {
  var selectors = {
    accordionHeader: '[js-accordion-header]',
    accordionContent: '[js-accordion-content]'
  }

  function SiteFooter(container) {
    this.$container = $(container);

    this.toggleAccordion()
  }

  SiteFooter.prototype = $.extend({}, SiteFooter.prototype, {
    toggleAccordion: function(container) {
      var $container = this.$container;
      var $headers = $(selectors.accordionHeader, $container);
      var $contents = $(selectors.accordionContent, $container);

      enquire.register(theme.config.mediaQueries.mediumUp,{
        match: function(){
          $headers.each(function(){
            $(this).attr('aria-expanded', 'true');
          })

          $contents.each(function(){
            $(this).attr('aria-hidden', 'false').removeAttr('style');
          })
        },
        unmatch: function(){
          $headers.each(function(i){
            if (i > 0) {
              $(this).attr('aria-expanded', 'false');
            }
          })

          $contents.each(function(i){
            if (i > 0) {
              $(this).attr('aria-hidden', 'true').attr("style", "display: none");
            }
          })
        }
      })
    }
  });

  return SiteFooter;
})();
/**
 * Product Card Script
 * ------------------------------------------------------------------------------
 */

theme.ProductCard = (function() {
  var selectors = {
    productCard: '#product-card'
  };
  var cache = {};

  function init() {
    cacheSelectors();
    initModal();
    openedModal();
    closedModal();
  }

  function cacheSelectors() {
    cache = {
      productCard: $(selectors.productCard)
    };
  }

  /**
   * Initialize modal
   */
  function initModal() {
    $(document).on("click", '[js-modal-trigger]', function(e) {
      var id = $(this).data('id');
      $('[data-remodal-id=modal-' + id + ']').remodal();
    });
  }

  /**
   * On opened modal
   */
  function openedModal() {
    $(document).on('opened', '.remodal', function () {
      var $remodal = $(this);
      var $carousel = $remodal.find('[js-product-card-carousel]');

      // Init flickity
      $carousel.flickity({
        cellAlign: 'left',
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        imageLoaded: true
      });

      // On carousel slide change
      $carousel.on('change.flickity', function(event, index) {
        var $navHighlight = $remodal.find('[js-product-nav]' + '[data-slide="' + index + '"]');
        $navHighlight.addClass('selected');
        $('[js-product-nav]').not($navHighlight).removeClass('selected');
      });

      // On navigation item click
      $remodal.find('[js-product-nav]').on('click', function() {
        var slide = $(this).data('slide');
        $carousel.flickity('select', slide, true, true);
        $(this).addClass('selected');
        $('[js-product-nav]').not($(this)).removeClass('selected');
      });

      // Disable button on open
      $('[data-add-to-cart]').prop('disabled', true);

      // Remove quantity error on open
      $('.qty-error').remove();

      // On ATC Click
      $remodal.on('click', '[js-product-card-quick-add]', function(e) {
        e.preventDefault();
        var variantId = $(this).siblings('[data-product-select]').find('option:selected').val();
        var variantQty = $(this).siblings('.product__form-qty').find('[js-product-card-quantity]').val();
        var data = { id: variantId, quantity: variantQty }

        e.stopPropagation();

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          async: false,
          dataType: 'json',
          data:  data,
          error: function(data, textstatus) {
            if (data.status === 422) {
              if ($('.qty-error').length == 0) {
                $('[data-product-form]').after('<div class="errors qty-error">All items are already in your cart</div>');
              }
            }
          },
          success: function(){
            $remodal.remodal().close();
            ajaxCart.load();
            return; 
          }
        })
      });

      // On variant change
      $remodal.on("click", '[js-product-card-swatch]', function(e) {
        var index = $(this).find("input").data('index');
        var $productSelect = $(this).parent().parent().siblings('[data-product-select]');
        var $productATC = $(this).parent().parent().siblings('[data-add-to-cart]');
        var $labelQty = $(this).parent().parent().siblings('[data-label-qty]').find('span');
        var $quantitySelect = $(this).parent().parent().siblings('.product__form-qty').find('[js-product-card-quantity]');
        var variantQuantity = $productSelect.find("[data-index='" + index + "']").data('quantity');

        // Add checked to radio input
        $('[js-product-card-swatch]').removeClass('product__swatch--active');
        $(this).addClass('product__swatch--active');

        // Apply selected to option
        $productSelect.find("option").attr('selected', false);
        $productSelect.find("[data-index='" + index + "']").attr('selected', "selected");

        // Update quantity options
        var list = '';
        $quantitySelect.empty();
        for (var i = 1; i <= variantQuantity; i++) {
          list += "<option value='" + i + "'>" + i + "</option>";
        }
        $quantitySelect.html(list);
        
        // Update availability label
        if (variantQuantity <= 0) {
          $labelQty.text('Sold out');
        } else {
          if (variantQuantity < 11) {
            $labelQty.text('Only ' + variantQuantity + " left!" );
          } else {
            $labelQty.text('Available');
          }
        }

        // Enable/disable button
        if ($productSelect.find("[data-index='" + index + "']").data('available')) {
          $productATC.prop('disabled', false);
          $productATC.html("ADD TO CART");
        } else {
          $productATC.prop('disabled', true);
          $productATC.html("SOLD OUT");
        }
      });

    });
  }

  /**
   * On closed modal
   */
  function closedModal() {
    // Destory flickity
    $(document).on('closed', '.remodal', function (e) {
      e.stopPropagation();
      var $carousel = $(this).find('[js-product-card-carousel]');
      if ($carousel.hasClass("flickity-enabled")) {
        $carousel.flickity('destroy')
      }
    });
  }

  return {
    init: init
  };
})();

/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#address_form_new');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  $('[js-address-edit]').on('click', function() {
    var formId = $(this).data('form-id');
    $('#address_form_' + formId).toggle();
    $('.account-address__edit').toggle();
    $('.account-address__listing').toggle();
  });

  $('[js-address-delete]').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '[js-show-recover]',
    hideRecoverPasswordLink: '[js-hide-recover]'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('.login__recover').toggle();
    $('.login__login').toggle();
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

theme.AccountDashboard = (function(){
  function AccountDashboard(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account__overview', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account__overview"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account__orders, #account__overview', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountDashboard;
})();

theme.AccountAddress = (function(){
  function AccountAddress(container) {
    this.$container = $(container);
    
    enquire.register(theme.config.mediaQueries.smallDown,{
      match: function(){
        $('#account-address-new', this.$container).attr('aria-hidden', true);
        $('[aria-controls="account-address-new"]', this.$container).attr('aria-expanded', false);
      },
      unmatch: function(){
        $('.account__accordion-header', this.$container).attr('aria-expanded', true)
        $('#account-address-new, #account-address-list', this.$container).removeAttr('aria-hidden').removeAttr('style')
      }
    })
  }

  return AccountAddress;
})();
theme.Collection = (function(){
  var selectors = {
    infiniteContainer: '[js-products]',
    infiniteObject: '[js-product]',
    paginationPath: '[js-pagination-path]'
  }

  function Collection(container) {
    this.$container = $(container);

    $(window).load(function() {
      $('#bc-sf-filter-tree-mobile button').show();
      $('#bc-sf-filter-tree-mobile button').text("Filters");
    });
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
  });

  return Collection;
})();

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('account-dashboard', theme.AccountDashboard);
  sections.register('account-address', theme.AccountAddress);
  sections.register('collection', theme.Collection);
  sections.register('featured-collection', theme.FeaturedCollection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('site-footer', theme.SiteFooter);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  // Checks if variant is current variant
  Handlebars.registerHelper('equalVariants', function(arg1, arg2, options) {
      return (arg1 == options.data.root.currentVariant) ? options.fn(this) : options.inverse(this);
  });

  // Checks if variant is available
  Handlebars.registerHelper('containsAvailableVariants', function(substring, string, options) {
     substring = Handlebars.escapeExpression(substring);
     string = Handlebars.escapeExpression(options.data.root.availableVariants);
     return (string.indexOf(substring) > -1) ? options.fn(this) : options.inverse(this);
  });

  // Checks if variant is selected value
  Handlebars.registerHelper('equalsSelectedValue', function(elem, list, options) {
    list = options.data.root.firstAvailableVarianOptions;
    return (list.indexOf(elem) > -1) ? options.fn(this) : options.inverse(this);
  });

  // Handleize string
  Handlebars.registerHelper('handleize', function(string, options) {
    var handle = string.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    return handle;
  });

  // Check if equals
  Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
    return (arg1 == arg2) ? options.fn(this) : options.inverse(this);
  });

  // For loop
  Handlebars.registerHelper('for', function(from, to, incr, block) {
    var accum = '';
    for(var i = from; i < to; i += incr)
        accum += block.fn(i);
    return accum;
  });

  Handlebars.registerHelper('lessThan', function(arg1, arg2, options) {
    return (arg1 < arg2) ? options.fn(this) : options.inverse(this);
  });

  // init mobile drawer
  theme.MobileNav.init();
  theme.Accordion.init();

  // init product card
  theme.ProductCard.init();
});
